export const BookmarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
      <path
        stroke="currentColor"
        strokeWidth="1.25"
        d="m11.653 15.913-6.628 4.42V4.5c0-.76.616-1.375 1.375-1.375h11.2c.76 0 1.375.616 1.375 1.375v15.832l-6.628-4.419-.347-.23z"
      ></path>
    </g>
  </svg>
);
